import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';
import ReactDOM from 'react-dom';
import { isApp, isBrowser, portalUri as staticPortalUri } from '../../../utils';
import PrimaryNavMobile from '../../wrapper/PrimaryNav/PrimaryNavMobile';

export const HeaderNavMobile = (props) => {
    const [apiNavigationTop, setApiNavigationTop] = useState({});
    const [viewportWidth, setViewportWidth] = useState();

    const fetchApiNavigationTop = useCallback(async () => {
        const rawLayoutUri = props.config.config.layout_uri || props.config.config.promotion_uri;
        if (rawLayoutUri && !isApp()) {
            try {
                const layoutUrl = new URL(rawLayoutUri);
                const layoutDomainName = layoutUrl?.hostname;
                let result;
                const fetchUrl = `https://${layoutDomainName}/api/navigation/level/top?screen_type=phone`;
                if (layoutUrl?.username && layoutUrl?.password) {
                    result = await fetch(fetchUrl, {
                        headers: { Authorization: 'Basic ' + btoa(layoutUrl.username + ':' + layoutUrl.password) },
                    });
                } else {
                    result = await fetch(fetchUrl);
                }
                const jsonResult = await result.json();
                setApiNavigationTop(jsonResult);
            } catch (error) {
                console.error(error);
            }
        }
    }, [props.config.config.promotion_uri, setApiNavigationTop]);

    useEffect(() => {
        fetchApiNavigationTop();
    }, [fetchApiNavigationTop]);

    const handleResize = () => {
        setViewportWidth(document.body.clientWidth);
        fetchApiNavigationTop();
    };

    useEffect(() => {
        setViewportWidth(document.body.clientWidth);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (isBrowser() && viewportWidth <= 1199) {
        // Only run this code on mobile to not cause issues with desktop
        const navWrapperMobile = document.getElementById('nav-mobile-header');
        const rawLayoutUri = props.config.config.layout_uri || props.config.config.promotion_uri;
        let portalUri;
        if (rawLayoutUri) {
            const layoutUrl = new URL(rawLayoutUri);
            const layoutDomainName = layoutUrl?.hostname;
            portalUri = `https://${layoutDomainName}/`;
        }
        const mobileLogoLinkElement = document.getElementById('pal-logo-mobile-link');
        if (mobileLogoLinkElement) {
            mobileLogoLinkElement.href = props.config.config.lottery_host; 
        }
        
        return navWrapperMobile
            ? ReactDOM.createPortal(<PrimaryNavMobile {...{ portalUri: portalUri || staticPortalUri, apiNavigationTop }} />, navWrapperMobile)
            : null;
    } else {
        return null;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderNavMobile);
